(async function () {
  const Layer = await waitForLayer();
  const { defineApp, register } = Layer.api.components;
  const { getItem, setItem } = Layer.api.storage;


  register(
    "u-quick-add",
    defineApp({
      name: "UQuickAddApp",
      props: {
        variantid: {
          type: "number",
          reflect: true,
        },
        oos: {
                    type: "boolean",
          default: false,
          reflect: true,
        }
      },
      setup(props, { expose, vue_lib }) {
        const { ref } = vue_lib;
       
        const loading = ref(false);

        async function addToCart() {
          const variantId = props.variantid;
          console.log(props)
          if (!variantId) return;
          if (loading.value) return;
          loading.value = true;
          await Layer.api.cart.addItem(variantId, 1);
          setTimeout(() => {
          loading.value = false;
          }, 1400)

        }

        return {
          loading,
          addToCart,
          oos: props.oos
        }
      },
      onConnected() {
       this.removeAttribute("u-cloak")
      }
    })
  );
})();
